/* eslint-disable @typescript-eslint/no-non-null-assertion */
import store from '../../index';
import {Action, Module, Mutation, VuexModule} from 'vuex-class-modules';
import {AppConfig, AuthSettings} from "../../../api/respresso-api";

@Module
class SettingsModule extends VuexModule {
	_authSettings: AuthSettings | null = null;
	_appConfig: AppConfig | null = null;

	get authSettings(): AuthSettings | null {
		return this._authSettings;
	}

	get appConfig(): AppConfig | null {
		return this._appConfig;
	}

	@Mutation
	SET_AUTH_SETTINGS(payload: AuthSettings | null): void {
		this._authSettings = payload;
	}

	@Mutation
	SET_APP_CONFIG(payload: AppConfig | null): void {
		this._appConfig = payload;
	}

	@Action
	remove(): void {
		this.SET_AUTH_SETTINGS(null);
		this.SET_APP_CONFIG(null);
	}

	@Action
	setAuthSettings(payload: AuthSettings): void {
		if (payload) {
			this.SET_AUTH_SETTINGS(payload);
		}
	}

	@Action
	setAppConfig(payload: AppConfig): void {
		if (payload) {
			this.SET_APP_CONFIG(payload);
		}
	}
}

export const settingsModule = new SettingsModule({ store, name: 'settings' });
